import { render } from "./needupload.vue?vue&type=template&id=62df1f06&scoped=true"
import script from "./needupload.vue?vue&type=script&lang=js"
export * from "./needupload.vue?vue&type=script&lang=js"

import "./needupload.vue?vue&type=style&index=0&id=62df1f06&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62df1f06"]])

export default __exports__